import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import { ModernStatWidget } from "../../Components/DashboardCard";

function SalesOrderSales() {
  const { data } = UseGetDashBoardData(`/dashboard/salesOrderStats`);
  const percentage = parseFloat(data?.this_month) || 0;
  const isNegative = percentage < 0;

  const OrderIcon = (
    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
  );

  return (
    <ModernStatWidget
      title="Orders from Customer"
      value={data?.total_sales_orders || 0}
      percentage={percentage}
      isNegative={isNegative}
      icon={OrderIcon}
      bgColor="bg-emerald-500/10"
      iconColor="text-emerald-600"
      badgeLabel="this month"
    />
  );
}

export default SalesOrderSales;
